import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const validateWithZod = (schema: any) => (values: any) => {
  try {
    schema.parse(values);
  } catch (err) {
    const errors: Record<string, string> = {};
    if (err instanceof z.ZodError) {
      err.issues.forEach(({ path, message }) => {
        if (path[0]) {
          errors[path[0].toString()] = message;
        }
      });
    }
    return errors;
  }
};
